const MAX_ENTRIES = 100

const initialState = () => ({
  liveActivityLog: []
})

export const state = () => initialState()

export const getters = {
  getLiveActivityLog: state => state.liveActivityLog
}

export const mutations = {
  addLogEntry(state, entry) {
    state.liveActivityLog.unshift({
      ...entry,
      timestamp: new Date().toISOString()
    })

    if (state.liveActivityLog.length > MAX_ENTRIES) {
      state.liveActivityLog = state.liveActivityLog.slice(0, MAX_ENTRIES)
    }
  },

  clearLog(state) {
    state.liveActivityLog = []
  }
}
